import React, { useState } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Button } from '../../Button'
import promiseMemoize from 'promise-memoize'

// Actions
import { modalActions } from '../../../_actions'

// Components
import { AutoCompleteInput } from '../../AutoCompleteInput'

// Services
import { createDebtor, getDebtors, createTenantDebtor } from '../../../_services/lender.service'
import { getDebtor } from '../../../_services/debtor.service'

// Helpers
import { createSearchParams } from '../../../_helpers/search'

const S_CreateDebtor = styled.div`
  max-width: 500px;

  .debtor-heading {
    margin-bottom: 10px;
  }
  .addBtn {
    margin-top: 16px;
    padding-left: auto;
  }
  .title {
    margin-bottom: 8px;
  }
  .body {
    margin-top: 8px;
  }
  .add-debtor-input {
    margin: 20px 0 20px;
  }

  .add-debtor-auto-complete {
    font-size: 13px;
    width: 100%;
    max-width: 250px;
    border-radius: 5px;
    border: 1px solid #ccc;
    padding: 8px;
    font-size: 16px;
    line-height: 17px;
    outline: none;
    transition: border 0.2s;
  }
`

const debtorValueFetch = promiseMemoize(getDebtor)

const CreateDebtor = ({ closeModal, setSelected = () => {} }) => {
  const [searchText, setSearchText] = useState(null)
  const [debtorId, setDebtorId] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  const fetchDebtorSuggestions = async (searchText) => {
    let searchParams = createSearchParams({
      searchTerm: searchText,
      searchParam: 'debtor_name',
    })
    searchParams.set('type', 'tenant')
    setIsLoading(true)
    let debtors = await getDebtors(searchParams.toString())
    setIsLoading(false)

    return debtors
  }

  return (
    <S_CreateDebtor>
      <h2>Create Debtor</h2>
      <div className={`add-debtor-input`}>
        <h4 className={`debtor-heading`}>Add Debtor</h4>
        <AutoCompleteInput
          checkInputValue={true}
          className={`add-debtor-auto-complete`}
          defaultSuggestion={'Start typing to find debtors'}
          fetchRecord={debtorValueFetch}
          fetchSuggestions={fetchDebtorSuggestions}
          isLoading={isLoading}
          onChange={(e) => setDebtorId(e.target.value)}
          onInputValueChange={(e) => setSearchText(e.target.value)}
          placeholder={'Find Debtor'}
          valueIdAttr={'id'}
          valueLabelAttr={'debtor_name'}
        />
      </div>

      <Button
        onClick={() => {
          closeModal()
          if (debtorId === null) {
            createDebtor(searchText).then((resp) => {
              createTenantDebtor(resp.id)
              setSelected(resp.id, searchText)
            })
          } else {
            createTenantDebtor(debtorId)
            getDebtor(debtorId).then((resp) => setSelected(debtorId, resp.debtor_name))
          }
        }}
        text={`Add Debtor`}
        type={`button`}
      />
    </S_CreateDebtor>
  )
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => {
      dispatch(modalActions.closeModal())
    },
  }
}

const ConnectedCreateDebtor = connect(null, mapDispatchToProps)(CreateDebtor)

export { ConnectedCreateDebtor as CreateDebtor }
